import { RegexConstants } from '../constants.js'

/* inspried by: https://medium.com/outsystems-experts/javascript-events-unmasked-how-to-create-an-input-mask-for-mobile-fc0df165e8b2,
                https://clark.engineering/input-on-android-229-unidentified-1d92105b9a04 */

/* NOTE:  on Android devices, many keys are returned as key 229 (Unidentified) and when that happens, preventDefault doesn't work.
          Therefore, we can't depend solely on 'keydown'.  We must include 'input' in on the fun.
*/

let keyDownValue = ''
let inputValue = ''
const regex = new RegExp(RegexConstants.numbersTest)

function filterOnKeyDown (event) {
  keyDownValue = event.target.value // Get the current value of the target

  if (!event.key) {
    return
  }

  const key = event.key.toLowerCase()
  const eventNames = ['backspace', 'delete', 'home', 'end', 'arrowup', 'arrowright', 'arrowdown', 'arrowleft', 'tab']

  // If the input isn't a number or one of the standard input field 'navigation' keys, don't allow the key
  if (!(regex.test(key) || eventNames.includes(key))) {
    if (event.preventDefault) {
      event.preventDefault()
    }
  }
}

function filterOnInput (event) {
  inputValue = event.target.value // Get the current value of the target

  /* Interestingly, on Android, if event.preventDefault is called in 'keydown', it still shows up on the screen, but doesn't get
     reflected in the event.target.value.

     So here, we're getting the difference between 'keydown' and 'input', giving us our entered character. */
  const keyPress = difference(keyDownValue, inputValue)

  // if it's not a number, remove it from the input's value
  if (!(regex.test(keyPress))) {
    event.target.value = event.target.value.replace(/\D/g, '')
  }
}

function difference (value1, value2) {
  const output = []
  for (let i = 0; i < value2.length; i++) {
    if (value1[i] !== value2[i]) {
      output.push(value2[i])
    }
  }
  return output.join('')
}

export const NumericDirective = {
  bind (el) {
    // set everything up
    el.addEventListener('keydown', filterOnKeyDown)
    el.addEventListener('input', filterOnInput)
  },
  unbind (el) {
    // clean up after ourselves
    el.removeEventListener('keydown', filterOnKeyDown)
    el.removeEventListener('input', filterOnInput)
  }
}
